// @flow strict

import * as React from 'react';
import styles from './styles.scss';
import Header from '../../components/Header';
import FormattedContent from '../../internal/FormattedContent';
import Iframe from '../../components/Iframe';
import MultiColumn from '../../components/MultiColumn';
import type { ColumnType } from '../../components/MultiColumn';
import type { CompleteRichText } from '../../internal/types';

type PropTypes = {|
  title: string,
  subtitle: string,
  intro: string,
  image: string,
  pardotFormUrl: string,
  pardotFormTitle?: string,
  content: {|
    title: string,
    items: Array<$Diff<ColumnType, { ctaText?: string, ctaHref?: string }>>,
    additionalInformation: CompleteRichText,
  |},
|};

export default (props: PropTypes) => {
  return (
    <div className={styles.root}>
      <Header title={props.title} subtitle={props.subtitle} image={props.image}>
        {props.intro}
      </Header>
      <div className={styles.wrapper}>
        <div className={styles.container}>
          <div className={styles.main}>
            {(props.content.title || props.content.items.length > 0) && (
              <MultiColumn
                title={props.content.title}
                items={props.content.items}
                color
                singleColumn
              />
            )}
            {props.content.additionalInformation && (
              <div className={styles.additionalInformation}>
                <FormattedContent>{props.content.additionalInformation}</FormattedContent>
              </div>
            )}
          </div>
          <div className={styles.aside}>
            {props.pardotFormTitle && <h2 className={styles.title}>{props.pardotFormTitle}</h2>}
            <Iframe src={props.pardotFormUrl} appliedMinHeight />
          </div>
        </div>
      </div>
    </div>
  );
};
